import React from 'react'
import {Link} from 'react-router-dom'
const Highlight = () => {
  return (
    <>
     <div className="highlights">
        <marquee behavior="smooth" direction="left"><p><Link to="" target="_blank">Stay connected for more updates! <i class="bi bi-paperclip"></i></Link></p></marquee>
     </div>
    </>
  )
}

export default Highlight;
